/**
 *
 * ParkingType14419 constants
 *
 */

export const UNLOADING_PARKING_TYPE = '3978595213000';
export const GUEST_PARKING_TYPE = '4058573898000';
